import { TFunction } from "i18next";
import { createI18nInstanceWithBackend, createHttpClient } from "@fortius/prime-ui";
import enTranslation from "./en.json";
import { APP_NAME } from "../constants";

const customAxiosClient = createHttpClient({
  baseURL: "",
  authorisationTokenProvider: async () => {
    return "";
  }
});

export const i18next = createI18nInstanceWithBackend({
  domainName: APP_NAME,
  translation: {
    en: enTranslation,
    fr: {},
    nl: {}
  },
  isDev: process.env.NODE_ENV === "development",
  customAxiosClient
});

export function changeLanguage(languageCode: string): Promise<TFunction> {
  return i18next.changeLanguage(languageCode, (error, t) => {
    document.title = t("signup.appName");
  });
}
